import React, { useEffect, useRef } from "react";

/**
 * Premium cursor: a small dot that tracks 1:1 + an outer ring that lags and
 * expands over interactive elements. Uses mix-blend-difference so it reads on
 * both light and dark sections. Disabled on touch / reduced-motion handled by CSS.
 */
export default function Cursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return undefined;
    if (window.matchMedia("(pointer: coarse)").matches) return undefined;

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let rx = x;
    let ry = y;
    let raf;

    const onMove = (e) => {
      x = e.clientX;
      y = e.clientY;
      dot.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
      const t = e.target.closest('[data-cursor="big"], a, button');
      ring.setAttribute("data-big", t ? "true" : "false");
    };

    const loop = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="studio-dot" aria-hidden="true" />
      <div ref={ringRef} className="studio-ring" data-big="false" aria-hidden="true" />
    </>
  );
}
